// import { createTheme, responsiveFontSizes, Shadows } from '@mui/material/styles';

// const defaultTheme = createTheme();
// const themeShadows: Shadows = [...defaultTheme.shadows]
// themeShadows["1"] = '0px 0px 6px rgba(0, 0, 0, 0.2)';

// const theme = createTheme({
//   shadows: themeShadows,
//   palette: {
//     primary: {
//       light: '#6D8B57', // Lighter shade of green as the primary color
//       main: '#789C5C', // Green as the primary color
//       dark: '#4F6D32', // Darker shade of green for contrast
//     },
//     secondary: {
//       light: '#D9894C', // Lighter shade of yellow as the secondary color
//       main: '#D9894C', // Dark brown as the secondary color,
//       dark: '#8A5837', // Darker shade of brown for contrast
//       contrastText: '#FFFFFF', // White text for contrast
//     },
//     background: {
//       default: '#F4F4F4', // Light background color for the page
//       paper: '#FFFFFF',
//     },
//     text: {
//       primary: '#1A1A1A', // Dark text color
//       secondary: '#4B2E11', // Secondary text using brown
//     },
//     action: {
//       active: '#F2994A', // Highlight or active color
//       hover: '#F2C94C', // Assuming a hover color slightly lighter than active
//       // make the selected-hover overlay lighter
//       // selectedOpacity: 0.70,
//       // (optionally tweak hover as well)
//       hoverOpacity: 0.2,
//     },
//   },
//   typography: {
//     fontFamily: [
//       'Manrope',
//       '-apple-system',
//       'BlinkMacSystemFont',
//       '"Segoe UI"',
//       '"Helvetica Neue"',
//       'Arial',
//       'sans-serif',
//       '"Apple Color Emoji"',
//       '"Segoe UI Emoji"',
//       '"Segoe UI Symbol"',
//     ].join(','),
//     h1: {
//       fontSize: '2rem',
//       fontWeight: 700,
//       color: '#789C5C', // Brown color for headings
//     },
//     h2: {
//       fontSize: '1.75rem',
//       fontWeight: 700,
//       color: '#789C5C',
//     },
//     h3: {
//       fontSize: '1.5rem',
//       fontWeight: 700,
//       color: '#789C5C',
//     },
//     h4: {
//       fontSize: '1.3rem',
//       color: '#0e0e0e'
//     },
//     h5: {
//       fontSize: '1.15rem',
//       fontWeight: 500,
//       color: '#1A1A1A',
//     },
//     h6: {
//       fontSize: '1rem',
//       fontWeight: 500,
//       color: '#789C5C',
//     },
//     body1: {
//       fontSize: '1rem',
//       color: '#0e0e0e',
//     },
//     body2: {
//       fontSize: '0.675rem',
//       color: '#0e0e0e',
//     },
//     subtitle1: {
//       fontSize: '0.9rem',
//     },
//     subtitle2: {
//       fontSize: '0.57rem',
//       fontWeight: 'normal'
//     }
//   },
//   components: {
//     MuiInputBase: {
//       styleOverrides: {
//         root: {
//           borderRadius: "8px",
//           backgroundColor: "rgba(255, 255, 255, 1)", // color-background-default-default
//           border: "1px solid rgba(217, 217, 217, 1)", // color-border-default-default
//         },
//       },
//     },
//     MuiOutlinedInput: {
//       styleOverrides: {
//         root: {
//           borderRadius: "8px",
//         },
//       },
//     },
//     MuiTooltip: {
//       styleOverrides: {
//         tooltip: {
//           boxShadow: themeShadows['0'],
//           fontSize: '1.1rem',
//           maxWidth: 500,
//         }
//       },
//       defaultProps: {
//         arrow: true,
//         slotProps: {
//           popper: {
//             modifiers: [
//               {
//                 name: 'offset',
//                 options: {
//                   offset: [0, -14],
//                 },
//               },
//             ],
//           },
//         }
//       }
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           padding: '6px 29px',
//           color: '#FFFFFF',
//           fontWeight: 'normal',
//           borderRadius: '4px',
//         },
//         containedPrimary: {
//           backgroundColor: '#4F6D32', // Matching the primary green color
//           '&:hover': {
//             backgroundColor: '#2b3c1b', // Slightly darker shade for hover
//           },
//           boxShadow: themeShadows["1"],
//         },
//         containedSecondary: {
//           color: '#1A1A1A',
//           backgroundColor: '#D9894C', // Matching the primary green color
//           '&:hover': {
//             backgroundColor: '#db9b6b', // Slightly darker shade for hover
//           },
//           boxShadow: themeShadows["1"],
//         },
//       },
//     },
//     MuiLink: {
//       defaultProps: {
//         underline: 'none',
//       }
//     },
//     MuiContainer: {
//       styleOverrides: {
//         root: ({ theme }) => ({
//           // override when width ≤ sm:
//           [theme.breakpoints.down('sm')]: {
//             paddingLeft: theme.spacing(2),
//             paddingRight: theme.spacing(2),
//           },
//         }),
//       },
//     },
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           borderRadius: '12px',
//           boxShadow: themeShadows["1"],
//           overflow: 'hidden',
//         },
//       },
//     },
//     MuiAppBar: {
//       styleOverrides: {
//         root: {
//           backgroundColor: '#789C5C', // Primary green color for AppBar
//           color: '#FFFFFF',
//         },
//       },
//     },
//     MuiChip: {
//       styleOverrides: {
//         root: {
//           backgroundColor: '#4B2E11', // Brown accent for chips
//           color: '#FFFFFF',
//           fontWeight: 600,
//           borderRadius: '10px',
//           boxShadow: themeShadows["1"]
//         },
//       },
//     },
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           borderRadius: 3.5
//         }
//       }
//     }
//   },
//   shape: {
//     borderRadius: 3.5,
//   }
// });

// export const MaterialUiTheme = responsiveFontSizes(theme);

import Add from "@mui/icons-material/Add";
import {
  createTheme,
  responsiveFontSizes,
  ThemeOptions
} from "@mui/material";
import React from "react";

let theme = createTheme({
  shape: {
    borderRadius: 0
  },
  // cssVariables: true,
  palette: {
    primary: {
      main: "#59A63A", // colours-new-brand-colours-green-dark (darkened from #6ABD45 for WCAG AA 3:1 contrast)
      dark: "#004E17", // colours-new-brand-colours-green-dark
      light: "#a2db89ff", // colours-new-brand-colours-green-dark
    },
    secondary: {
      main: "#4B0F04", // colours-new-brand-colours-brown-dark
    },
    error: {
      main: "#E22339", // colours-status-error
    },
    warning: {
      main: "#FFCC2C", // colours-status-caution
    },
    info: {
      main: "#0085B3", // colours-status-info
    },
    success: {
      main: "#339D37", // colours-status-success
    },
    text: {
      primary: "#1A1A1A", // colours-light-text-text
      secondary: "#414141", // color-light-text-text-duplicate
      disabled: "#787979", // colours-neutral-dark
    },
    background: {
      default: "#FFFFFF", // colours-neutral-white
      paper: "#F6F4F1", // core-neutral-white-duplicate
    },
    action: {
      active: "#445239", // colours-new-brand-colours-green-dark
      hover: "#83A87B", // colours-new-brand-colours-green-light
    },
    // Custom colors from tailwind config
    // brandGreenDark: {
    //   main: "#445239", // colours-new-brand-colours-green-dark
    // },
    brandGreenLight: {
      main: "#83A87B", // colours-new-brand-colours-green-light
    },
    brandBrownDark: {
      main: "#4B0F04", // colours-new-brand-colours-brown-dark
    },
    brandBrownLight: {
      main: "#99551F", // colours-new-brand-colours-brown-light
    },
    brandGreen: {
      main: "#59A63A", // colours-new-brand-colours-green (darkened from #6ABD45 for WCAG AA contrast)
    },
    brandBlack: {
      main: "#000000", // colours-new-brand-colours-black
    },
    brandBlueDark: {
      main: "#394F6A", // colours-new-brand-colours-blue-dark
    },
    brandBlueLight: {
      main: "#97B8C4", // colours-new-brand-colours-blue-light
    },
    brandPeach: {
      main: "#FFCAA6", // colours-new-brand-colours-peach
    },
    brandTan: {
      main: "#BFA88C", // colours-new-brand-colours-tan
    },
    brandYellowDark: {
      main: "#C8AF22", // colours-new-brand-colours-yellow-dark
    },
    brandYellowLight: {
      main: "#FFF9E1", // colours-new-brand-colours-yellow-light
    },
    accent: {
      main: "#5F2116", // colours-colorlight-accent-accent
      dark: "#8CB270", // colours-colordark-accent-accent
    },
    priorityHigh: {
      main: "#C34116", // colours-priority-colour-high
    },
    priorityModerate: {
      main: "#E3891A", // colours-priority-colour-moderate
    },
    priorityLow: {
      main: "#83A87B", // colours-priority-colour-low
    },
    link: {
      main: "#09549F", // color-light-link-link
    },
    border: {
      main: "#7A7A7A", // color-light-border-border-alt
    },
  },
  typography: {
    fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
    h1: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "40px",
      fontWeight: 600,
      // lineHeight: "56px",
      letterSpacing: "0px",
    },
    h2: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "32px",
      fontWeight: 600,
      // lineHeight: "40px",
      letterSpacing: "0px",
    },
    h3: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "28px",
      fontWeight: 500,
      // lineHeight: "39.2px",
      letterSpacing: "0px",
    },
    h4: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "24px",
      fontWeight: 700,
      // lineHeight: "33.6px",
      letterSpacing: "0px",
    },
    h5: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "24px",
      fontWeight: 500,
      // lineHeight: "33.6px",
      letterSpacing: "0px",
    },
    h6: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "20px",
      fontWeight: 600,
      // lineHeight: "32px",
      letterSpacing: "0px",
    },
    subtitle1: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "24px",
      fontWeight: 400,
      // lineHeight: "33.6px",
      letterSpacing: "0px",
    },
    subtitle2: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "18px",
      fontWeight: 500,
      // lineHeight: "32px",
      letterSpacing: "0px",
    },
    body1: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "16px",
      fontWeight: 400,
      // lineHeight: "24px",
      letterSpacing: "0px",
    },
    body2: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "14px",
      fontWeight: 400,
      // lineHeight: "22.4px",
      letterSpacing: "0px",
    },
    button: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "16px",
      // lineHeight: "24px",
      letterSpacing: "0px",
      fontWeight: 'normal'
    },
    caption: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "14px",
      fontWeight: 400,
      // lineHeight: "20px",
      letterSpacing: "0px",
    },
    overline: {
      fontFamily: '"Manrope", Helvetica, Arial, sans-serif',
      fontSize: "24px",
      fontWeight: 600,
      // lineHeight: "32px",
      letterSpacing: "0px",
    },
  },
  shadows: [
    "none",
    "0px 1px 3px 1px rgba(0, 0, 0, 0.1), 0px 1px 2px 0px rgba(0, 0, 0, 0.2)", // shadow-level-1
    "0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)", // shadow-level-2
    "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 4px 8px 3px rgba(0, 0, 0, 0.1)", // shadow-level-3
    // Rest of the default shadows
    "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
    "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
    "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
    "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
    "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
    "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
    "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
    "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
    "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
    "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
    "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
    "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
    "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
    "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
  ],
  components: {
    // ──────────────────────────────────────────────────────────────────────────
    MuiAccordion: {
      defaultProps: {
        square: true, // remove the default rounded corners so we can control them ourselves
      },
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          boxShadow: 'none',
          border: `1px solid ${theme.palette.grey[300]}`,
          backgroundColor: 'white',
          marginBottom: '16px',
          borderRadius: '30px',       // e.g. 8px
          // '&:not(:last-of-type)': {
          //   borderBottom: 'none',      // stitch adjacent panels together
          // },
          '&:before': {
            // remove the divider line that MUI injects
            display: 'none',
          },
          '&.Mui-expanded': {
            // margin: 0,                  // cancel the default margin on expand
            borderColor: theme.palette.primary.main, // highlight border when open
          },
        }),
      },
    },


      // MuiInput: {
      //   defaultProps: {
      //
      //   },
      //
      //     styleOverrides: {
      //         root: ({ ownerState }) => ({
      //             padding: '0 24px',
      //             minHeight: 56,
      //             '&.Mui-expanded': {
      //                 minHeight: 56,
      //             },
      //         }),
      //     }
      // },

    // ──────────────────────────────────────────────────────────────────────────
    MuiPopover: {
      styleOverrides: {
        paper: {
          padding: '10px'
        }
      }
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '36px'
        }
      }
    },

    MuiAccordionSummary: {
      defaultProps: {
        expandIcon: <Add />,      // use a “+” by default
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          padding: '0 24px',
          minHeight: 56,
          '&.Mui-expanded': {
            minHeight: 56,
          },
        }),

        // content: {
        //   margin: 0,
        //   '&.Mui-expanded': {
        //     margin: 0,
        //   },
        // },
        expandIconWrapper: ({ theme }) => ({
          marginLeft: 10,
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
          }),
          '&.Mui-expanded': {
            // rotate your “+” into an “×” (you can swap to RemoveIcon in your component if you want a true “–”)
            transform: 'rotate(45deg)',
            color: theme.palette.primary.main,
          },
        }),
      },
    },

    // ──────────────────────────────────────────────────────────────────────────
    MuiAccordionDetails: {
      defaultProps: {
        sx: {
          padding: {
            xs: '0 15px 16px',
            sm: '0 18px 16px',
            md: '0 24px 16px',

          }
        }
      },
      styleOverrides: {
        root: ({ theme }) => ({
          borderTop: `1px solid ${theme.palette.grey[300]}`,
        }),
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: '14px'
        },
        contained: {
          boxShadow: 'none',
          fontWeight: 'normal',
          borderRadius: '14px'
        },
        text: {
          textDecoration: 'none'
        },
        textPrimary: {
          textDecoration: 'none'
        },
        textSecondary: {
          textDecoration: 'none'
        },
        containedPrimary: {
          color: 'white',
          // primary.dark (#004E17, ~14:1 with white) instead of primary.main (#59A63A, 3.02:1)
          // so white button text passes WCAG AA 4.5:1 for normal-weight body text.
          backgroundColor: '#004E17',
          fontWeight: 'bold',
          borderRadius: '14px',
          '&:hover': {
            backgroundColor: '#59A63A',
          },
          '&.Mui-disabled': {
            color: '#6d6d6d',
            backgroundColor: '#afb1ae',
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: '20px'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '20px',
            backgroundColor: 'white',

          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '2px!important'
          },

          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderWidth: '2px!important'
          },
        },
      },
    },

    ['MuiPickersInputBase' as any]: {
      styleOverrides: {
        root: {
          borderRadius: '20px'
        },
      }
    },
    ['MuiPickersOutlinedInput' as any]: {
      styleOverrides: {
        root: {
          borderRadius: '20px'
        },
      }
    },

    MuiDialogActions: {
      styleOverrides: {
        root: ({ theme }: any) => ({
          '& .MuiButton-textPrimary': {
            color: theme.palette.primary.dark,
          },
        }),
      }
    },

    // MUI X Date Pickers: make the current day a filled red circle
    ['MuiPickersDay' as any]: {
      styleOverrides: {
        root: ({ theme }: any) => ({
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main + '!important',
            color: theme.palette.common.white,
          },
          '&.Mui-disabled': {
            color: '#787979',
            borderColor: theme.palette.common.white + '!important',
          }
        }),
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          // override when width ≤ sm:
          [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
          },
        }),
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'always',
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: ({ theme }) => ({
          ...theme.typography.subtitle2,
        }),
        secondary: ({ theme }) => ({
          ...theme.typography.body1,
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "0.75rem", // rounded-xl from tailwind
        },
      },
    },
  },
})

theme = createTheme(theme, {
  palette: {
    secondary: theme.palette.augmentColor({
      color: {
        main: "#4B0F04", // colours-new-brand-colours-brown-dark
      },
      name: 'secondary',
    }),
    brandGreen: theme.palette.augmentColor({
      color: {
        main: "#6ABD45",
      },
      name: 'brandGreen',
    }),
  }
} as ThemeOptions);

export const appTheme = responsiveFontSizes(theme)